import { useRef, useState } from 'react'

import { Modal } from 'react-bootstrap'
import { toast } from 'react-toastify'
import ReclamacoesService from '../../../services/database/ReclamacoesService'
import { sendErrorApiMessage } from '../../../utils/sendErrorApiMessage'
import { FormReclamacao } from '../FormReclamacao'

export function ModalCreate({ loadReclamacoes, isOpen, onClose }) {
  const formReclamacaoRef = useRef(null)

  const [isRequestLoading, setIsRequestLoading] = useState(false)

  async function handleSubmit() {
    try {
      setIsRequestLoading(true)

      const data = formReclamacaoRef?.current.getReclamacao()

      await ReclamacoesService.create(data)

      toast.success('Reclamação criada com sucesso!')
      onClose()
      loadReclamacoes()
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível criar a reclamação!')
    } finally {
      setIsRequestLoading(false)
    }
  }

  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      dialogClassName="custom-modalzpl"
    >
      <div
        style={{
          padding: 20,
        }}
      >
        <FormReclamacao
          ref={formReclamacaoRef}
          onSubmit={handleSubmit}
          onClose={onClose}
          isRequestLoading={isRequestLoading}
        />
      </div>
    </Modal>
  )
}
